import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createCollaboratorEventAsync, deleteCollaboratorEventAsync, getAllCollaboratorEventsAsync, getCollaboratorEventByIdAsync, updateCollaboratorEventAsync } from './collaboratorEventThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const collaboratorEventSlice = createSlice({
    name: 'collaboratorEvent',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createCollaboratorEventAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCollaboratorEventAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorEvent = action.payload;
        })
            .addCase(createCollaboratorEventAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCollaboratorEventAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCollaboratorEventAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorEvent = action.payload;
        })
            .addCase(updateCollaboratorEventAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllCollaboratorEventsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCollaboratorEventsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorEvents = action.payload;
        })
            .addCase(getAllCollaboratorEventsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCollaboratorEventByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCollaboratorEventByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorEvent = action.payload;
        })
            .addCase(getCollaboratorEventByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCollaboratorEventAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCollaboratorEventAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteCollaboratorEventAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default collaboratorEventSlice.reducer;
